import {Route, Routes, BrowserRouter as Router} from "react-router-dom"

import DavidFooter from "./DavidFooter";
import Nav from "./Nav";
import TuskyTime from "./TuskyTime";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA62gZmAbAqVdl7ySW9tZlKvIDUBi71ydQ",
  authDomain: "tuskytime.firebaseapp.com",
  projectId: "tuskytime",
  storageBucket: "tuskytime.appspot.com",
  messagingSenderId: "462748644600",
  appId: "1:462748644600:web:77801fadbdfac90f37f70d",
  measurementId: "G-RHMV5QC0XJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



function App() {
  return (
    <Router id="app">
      <Nav/>
      
      <Routes>
        <Route path="/" element={<TuskyTime/>}></Route>
      </Routes>
      <DavidFooter/>
      </Router>
  );
}

export default App;
